module.exports = __webpack_public_path__ + "media/item_reveal6_ancient.9004fb49.wav";